import moment from 'moment';
import { useCallback, useMemo, memo } from "react"
import { SelectInput, FormRow, Label } from "../Form"
import { Column, ContentArea } from "../Layout"
import { CardDefault } from "../Card"
import { VariableSizeList as List } from "react-window"
import "./styles.scss"

const formatJson = (data) => {
  try {
    return JSON.parse(data) || []
  } catch (e) {
    return []
  }
}

export const Sidebar = ({
  title = "",
  content = [],
  selectOptions,
  control,
  setDetails,
  onChange,
  data
}) => {
  const Row = useCallback(
    ({ index, style }) => {
      const item = content[index]
      const categories = formatJson(item.categories)
      return (
        <div style={style}>
          <CardDefault
            key={index}
            color="tertiary"
            label={item.PostTitle}
            image={item.PostImage}
            hasCheckInImage={item?.evidenceDetail}
            year={moment(item.Inicio?.value).format("YYYY")}
            Trilha={item.Trilha}
            description={categories ? categories.join(",") : ""}
            hasValue={data.find(item => item.muralId === content[index].PostId)}
            handleClick={() => setDetails({ postId: content[index].PostId, year: moment(item.Inicio?.value).format("YYYY")})}
            squareImage
            noFlexWrap
          />
        </div>
      )
    },
    [JSON.stringify(content)],
  )

  return useMemo(
    () => (
      <div className="sidebar__container">
        <ContentArea direction={"column"} scroll>
          <div className="sidebar-title">{title}</div>
          {(selectOptions && selectOptions.length > 0) && <div className="sidebar__select">
            <FormRow>
              <Label label="Selecione a Trilha" color="primary-green-dark" />
              <Column cols={12} noPadding>
                <SelectInput
                  name="typeQuestion"
                  placeholder="Selecione"
                  options={selectOptions}
                  control={control}
                  isRequired
                  handleChange={onChange}
                />
              </Column>
            </FormRow>
          </div>}
          <ContentArea direction={"column"} scroll noPadding>
            <List
              height={670}
              itemCount={content.length}
              itemSize={() => 100}
              width={"100%"}
              className="scroll">
              {Row}
            </List>
          </ContentArea>
        </ContentArea>
      </div>
    ),
    [JSON.stringify({content, selectOptions})],
  )
}

export const LogoSideBar = ({ logoImage, currentPlatform, isMobile }) => {
  return (
    <div className={`sidebar-logo ${isMobile ? `sidebar-logo-mobile sidebar-logo-mobile--${currentPlatform}` : `sidebar-logo--${currentPlatform}`} `}>
      <img className={`sidebar-logo__img sidebar-logo__img--${currentPlatform}`} src={logoImage} alt={`Logo da Empresa ${currentPlatform}`} />
    </div>
  )
}
